import React from 'react';

export default function Refund() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <span style={styles.logo}><span style={{color:'#fff'}}>Family</span><span style={{color:'#D4A017'}}>Bandhan</span></span>
        </div>
        <h1 style={styles.title}>Refund Policy</h1>
        <p style={styles.meta}>Effective date: 17 June 2026 · LBLOGIC Solutions (OPC) Private Limited</p>

        <Section title="1. General Policy">
          All payments made for Family Premium on FamilyBandhan are non-refundable. By completing a payment, you acknowledge and accept this policy.
        </Section>

        <Section title="2. Exceptions">
          We will consider a refund only in the following two cases: (a) a duplicate charge where your account was billed more than once for the same subscription period, or (b) a technical failure where payment was deducted but Premium was not activated on your account within 24 hours. In either case, write to support@familybandhan.in with your registered email address and payment reference number within 7 days of the transaction.
        </Section>

        <Section title="3. Cancellation">
          You may stop using FamilyBandhan at any time. If you choose not to renew your Family Premium subscription, your Premium access will remain active until the end of your current annual period. There is no pro-rata refund for unused days. FamilyBandhan does not auto-renew subscriptions — you will need to pay again manually when your year ends.
        </Section>

        <Section title="4. Payment Processing">
          All payments are processed securely by Razorpay. FamilyBandhan does not store your card or UPI details. For payment disputes, you may also raise a concern directly with Razorpay or your bank.
        </Section>

        <Section title="5. Grievance Redressal">
          For any billing concern, contact us at support@familybandhan.in. We aim to respond within 3 business days. Grievance Officer: LBLOGIC Solutions (OPC) Private Limited, Bengaluru, Karnataka, India.
        </Section>

        <div style={styles.footer}>
          <a href="/" style={styles.link}>← Back to FamilyBandhan</a>
          <span style={styles.sep}>·</span>
          <a href="/terms" style={styles.link}>Terms of Use</a>
          <span style={styles.sep}>·</span>
          <a href="/privacy" style={styles.link}>Privacy Policy</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '24px' }}>
      <h2 style={{ fontSize: '15px', color: '#1a0533', marginBottom: '6px' }}>{title}</h2>
      <p style={{ fontSize: '14px', color: '#4B5563', lineHeight: 1.7, margin: 0 }}>{children}</p>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', background: '#f8f7ff',
    padding: '32px 16px', fontFamily: "'DM Sans', Arial, sans-serif",
  },
  card: {
    maxWidth: '720px', margin: '0 auto',
    background: '#ffffff', borderRadius: '16px',
    padding: '40px 36px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
  },
  header: {
    marginBottom: '24px',
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '22px', background: '#0e0018',
    padding: '10px 20px', borderRadius: '8px',
    display: 'inline-block',
  },
  logo: { letterSpacing: '0.5px' },
  title: { fontSize: '26px', color: '#1a0533', marginBottom: '4px' },
  meta: { fontSize: '12px', color: '#9CA3AF', marginBottom: '32px' },
  footer: {
    marginTop: '40px', paddingTop: '20px',
    borderTop: '1px solid #E5E7EB',
    display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center',
  },
  link: { fontSize: '13px', color: '#7C3AED', textDecoration: 'none' },
  sep: { color: '#D1D5DB', fontSize: '13px' },
};
